import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBroadcomComponent } from './simple-icons-broadcom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBroadcomComponent ],
    exports:      [ SimpleIconsBroadcomComponent ],
    bootstrap:    []
})
export class SimpleIconsBroadcomModule {}
